<template>
  <form autocomplete="off">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content v-if="everythingLoaded">
        <ValidationProvider
          name="name"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Veld type naam</label>
            <md-input v-model="name" type="text" disabled="disabled">
            </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="label"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Veld type label</label>
            <md-input v-model="label" type="text" disabled="disabled">
            </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <template>
          <h4 class="card-title">Opties</h4>
          <p>
            Opties die zijn uitgeschakeld zijn in gebruik en kunnen hierdoor
            niet aangepast worden. In plaats van de verwijder button wordt er
            aangegeven hoevaak deze optie in gebruik is. Deze opties kunnen wel
            gesorteerd worden.
          </p>
          <ol>
            <template v-for="(option, key) in options">
              <li :key="key">
                <md-field>
                  <md-input
                    v-model="options[key]['label']"
                    :disabled="option.usages > 0"
                  >
                  </md-input>
                  <md-input
                    v-model="options[key]['value']"
                    :disabled="option.usages > 0"
                  >
                  </md-input>
                  <md-button
                    :disabled="key === 0"
                    :class="[{ 'md-success': key > 0 }]"
                    class="md-just-icon"
                    @click.native="sortUpward(key)"
                  >
                    <md-icon>arrow_upward</md-icon>
                  </md-button>
                  <md-button
                    :disabled="key === options.length - 1"
                    :class="[{ 'md-success': key < options.length - 1 }]"
                    class="md-just-icon"
                    @click.native="sortDownward(key)"
                  >
                    <md-icon>arrow_downward</md-icon>
                  </md-button>
                  <md-button
                    :disabled="option.usages > 0"
                    :class="[{ 'md-danger': option.usages === 0 }]"
                    class="md-just-icon"
                    @click.native="removeOption(key)"
                    :title="option.usages + ' keer in gebruik'"
                  >
                    <template v-if="option.usages === 0">
                      <md-icon>close</md-icon>
                    </template>
                    <template v-if="option.usages > 0">
                      {{ option.usages }}
                    </template>
                  </md-button>
                </md-field>
              </li>
            </template>
          </ol>
        </template>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug</md-button
        >
        <md-button
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      name: "",
      label: "",
      options: [],
      touched: {
        name: false,
        label: false,
        options: false
      },
      loaded: {
        fieldTypeOptions: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      if (this.$route.params.id !== undefined) {
        this.loadUserFieldTypeOptions(this.$route.params.id);
      } else {
        this.name = "";
        this.label = "";
        this.options = [];

        setTimeout(this.resetTouched, 100);
      }
    },
    validate() {
      let options = this.options;
      if (options[0]["value"] === "" || options[0]["value"] === null) {
        options[0]["value"] = "null";
      }

      this.$http
        .post(
          this.$apiBaseUrl +
            "users/field/type/" +
            this.$route.params.id +
            "/editable-options",
          Object.assign({
            options: options
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Gebruikers veld type opties succesvol opgeslagen",
              "check",
              "success",
              5000
            );
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan veld type opties",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    saveUserFieldGroupUserRoles(id) {
      this.$http
        .post(
          this.$apiBaseUrl +
            "users/field/group/" +
            this.$route.params.id +
            "/roles",
          Object.assign({
            roleIds: this.allRolesBooleansSelectedRoleIds
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Gebruikers veld groep succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            // Go back when user roles have changed to prevent conflicts between user/driver only groups switching and then getting permission errors from the API
            this.$router.go(-1);
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan route",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    loadUserFieldTypeOptions(id) {
      this.requesting = true;
      this.$http
        .get(this.$apiBaseUrl + "users/field/type/" + id + "/editable-options")
        .then(
          response => {
            this.name = response.data.fieldType.name;
            this.label = response.data.fieldType.label;
            this.options = response.data.options;

            setTimeout(this.resetTouched, 100);

            this.requesting = false;
            this.loaded.fieldTypeOptions = true;
          },
          response => {
            this.requesting = false;
            if (response.status === 403) {
              // this.notifyVue("U heeft geen rechten voor het beheren van veld groupen", 'add_alert', 'danger', 0);
            }
          }
        );
    },
    resetTouched() {
      this.touched.name = false;
      this.touched.label = false;
      this.touched.options = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    sortUpward(index) {
      this.options = this.arraySwapItems(this.options, index, index - 1);
    },
    sortDownward(index) {
      this.options = this.arraySwapItems(this.options, index, index + 1);
    },
    removeOption(index) {
      this.showSwalDeleteOption(index);
    },
    showSwalDeleteOption(index) {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u deze optie wilt verwijderen?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, verwijder optie",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.options.splice(index, 1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    }
  },
  watch: {
    name() {
      if (!this.requesting) {
        this.touched.name = true;
      }
    },
    label() {
      if (!this.requesting) {
        this.touched.label = true;
      }
    },
    // options() {
    //   if (!this.requesting) {
    //     this.touched.options = true;
    //   }
    // },
    options: {
      handler: function(val, oldVal) {
        this.touched.options = true;
      },
      deep: true
    },
    $route(to, from) {
      this.init();
    }
  },
  computed: {
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    },
    userRoleIds: function() {
      let data = [];

      for (let i in this.userRoles) {
        data.push(this.userRoles[i].id);
      }

      return data;
    },
    allRolesBooleansSelectedRoleIds: function() {
      let data = [];

      for (let i in this.allRolesBooleans) {
        if (this.allRolesBooleans[i]) {
          data.push(this.allRoles[i].id);
        }
      }

      return data;
    },
    title: function() {
      return "Gebruikers veld type opties bewerken";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "table_rows";
      }
      return "table_rows";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
.md-field input:disabled {
  background-color: #eee;
}
</style>
